import React from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

import Header from "components/library/Header";
import HeaderLinkGroup from "dashboard/components/HeaderLinkGroup";
import NewItemDropdown from "dashboard/components/NewItemDropdown";
import SearchIcon from "dashboard/components/SearchIcon";
import SearchBar from "dashboard/components/SearchBar";
import WithPermissions from "components/library/WithPermissions";
import logo from "assets/img/logo.png";

import styles from "./NavigationHeader.css";

class NavigationHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
      isDropdownOpen: false,
      isSearchActive: this.props.location.pathname.includes("search"),
      isSearchFocused: false,
    };

    this.toggleDropdownOpen = this._toggleDropdownOpen.bind(this);
    this.toggleSearch = this._toggleSearch.bind(this);

    this.dashboardLinks = [
      { to: "/dashboard/", children: "Drafts" },
      { to: "/dashboard/published", children: "Published" },
    ];
    this.settingsLinks = [
      // { to: "/settings/trending", children: "Trending topics" },
      {
        to: "/settings/features",
        children: (
          <WithPermissions required={["config.feature.special_features_list"]}>
            Special features
          </WithPermissions>
        ),
      },
      { to: "/settings/tags", children: "Tags" },
      { to: "/settings/users", children: "Users" },
      { to: "/illos", children: "Illos" },
    ];
    this.moreLinks = [
      { to: "/settings/user/me", children: "Your account" },
      { to: "/logout/", children: "Log out" },
    ];

    this.newItemLinks = [
      { icon: "file-text", children: "Story", to: "/editor/story/" },
      { icon: "mail", children: "Newsletter", to: "/editor/newsletter/" },
    ];
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({
        isSearchActive: nextProps.location.pathname.includes("search"),
      });
    }
  }

  _toggleDropdownOpen() {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
  }

  _toggleSearch() {
    this.setState({ isSearchActive: !this.state.isSearchActive });
  }

  _setSearchFocus(isSearchFocused) {
    this.setState({ isSearchFocused });
  }

  render() {
    if (this.state.isSearchActive) {
      return (
        <div className={styles.root}>
          <Header className={styles.searchHeader}>
            <SearchIcon
              isFocused={this.state.isSearchFocused}
              onClick={this.toggleSearch}
              isActive={this.state.isSearchActive}
            />
            <SearchBar
              onFocus={() => this._setSearchFocus(true)}
              onBlur={() => this._setSearchFocus(false)}
            />
          </Header>
          <Header
            className={styles.mobileHeader}
            center={<HeaderLinkGroup links={this.dashboardLinks} />}
          />
        </div>
      );
    } else {
      return (
        <div className={styles.root}>
          <Header
            left={
              <SearchIcon
                onClick={this.toggleSearch}
                isActive={this.state.isSearchActive}
              />
            }
            center={
              <>
                <HeaderLinkGroup
                  className={styles.desktopHeaderLinks}
                  links={this.dashboardLinks}
                />
                <img src={logo} className={styles.logo} />
              </>
            }
            right={<NewItemDropdown items={this.newItemLinks} />}
          />
          <Header
            className={styles.mobileHeader}
            center={<HeaderLinkGroup links={this.dashboardLinks} />}
          />
        </div>
      );
    }
  }
}

NavigationHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

export default withRouter(NavigationHeader);
